import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile } from "src/uicomponents/components/utilities";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import  { TransactionListView } from "./transactionList-view"

export class TransactionListViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'لیست واریزی ها';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.transactions = ObservableArray.create<transaction>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),150);
        this.reportTypes = ObservableArray.create<reportType>();
        this.reportTypes.update(...[
            new reportType(this,'بررسی نشده',false,true,false,false),
            new reportType(this,'تایید شده',false,false,true,false),
            new reportType(this,'رد شده',false,false,false,true),
            new reportType(this,'همه',true,false,false,false),
        ]);
        this.selectedReportType = this.reportTypes[0];
        this.from = moment.utc();
        this.until = moment.utc();
    }
    GetDefaultView(): View <ViewModel> {
        return new TransactionListView();
    }
    public getTypeId(): string {
        return "VM-D8D04125-8452-4020-A2BC-614ADC854F0F"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set reportTypes(v: ObservableArray<reportType>) { this._reportTypes = v; } public get reportTypes(): ObservableArray<reportType> { return this._reportTypes;} private _reportTypes: ObservableArray<reportType>;
    public set selectedReportType(v: reportType) { this._selectedReportType = v; } public get selectedReportType(): reportType { return this._selectedReportType;} private _selectedReportType: reportType;
    public set transactions(v: ObservableArray<transaction>) { this._transactions = v; } public get transactions(): ObservableArray<transaction> { return this._transactions;} private _transactions: ObservableArray<transaction>;
   
   
    public set from(v: moment.Moment) { 
        let v2 = v.clone().local().hour(0).minute(0).second(0).millisecond(0)
        this._from = v2; 
    } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { 
        let v2 = v.clone().local().hour(23).minute(59).second(59).millisecond(999)
        this._until = v2; 
    } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;

    load(){
        this.loader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/TransactionsList',{
                ShowAll : this.selectedReportType.showAll,
                NotChecked:this.selectedReportType.notChecked,
                Confirmed:this.selectedReportType.confirmed,
                NotConfirmed:this.selectedReportType.rejected,
                From:this.from,
                Until:this.until,
                FurtherQueryInfo:filteringInformation

            });
            this.transactions.update(...result.Transactions.map((x,i)=>{
                let r = new transaction(this);
                r.id = x.Id;
                r.index = i+1;
                r.sourceCard = x.PayerCardNo;
                r.destinationCard = x.ReceiverCardNumber;
                r.traceCode = x.TraceCode;
                r.amount = x.Amount;
                r.isSpecified = x.IsConfirmed==null ? false : true,
                r.status = x.IsConfirmed==null ? 'بررسی نشده' : x.IsConfirmed==true 
                    ? 'تایید شده' 
                    : 'رد شده';
                r.time = moment.utc(x.TransactionDateTime);
                r.creationTime = moment.utc(x.CreationTime);
                r.bankName = x.BankName;
                r.accountName = x.AccountName;
                r.accountNumber = x.AccountNumber;
                r.factorNo = x.FactorNo;
                r.payerName = x.PayerName;
                r.fileId = x.FileContentId;
                r.fileName = x.FileName;
                r.hasAttachment = x.HasAttachment;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(1,1);
        } finally {
            this.isLoading = false;
        }
    }
    async downloadAttachment(fileId: string, fileName: string) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/GetTransactionAttachmentFileContent',{
                FileId : fileId
            });
            downloadFile(result.FileContent,fileName);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class reportType extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,name:string,showAll:boolean,notChecked:boolean,confirmed:boolean,rejected:boolean) {
        super(parent);
        this.name = name;
        this.showAll = showAll;
        this.notChecked = notChecked;
        this.confirmed = confirmed;
        this.rejected = rejected;
    }
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public showAll:boolean;
    public notChecked:boolean;
    public confirmed:boolean;
    public rejected:boolean;
    
}
export class transaction extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:TransactionListViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent : TransactionListViewModel;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    
    public set sourceCard(v: string) { this._sourceCard = v; } public get sourceCard(): string { return this._sourceCard;} private _sourceCard: string;
    public set destinationCard(v: string) { this._destinationCard = v; } public get destinationCard(): string { return this._destinationCard;} private _destinationCard: string;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set status(v: string) { this._status = v; } public get status(): string { return this._status;} private _status: string;
    public set isSpecified(v: boolean) { this._isSpecified = v; } public get isSpecified(): boolean { return this._isSpecified;} private _isSpecified: boolean;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set bankName(v: string) { this._bankName = v; } public get bankName(): string { return this._bankName;} private _bankName: string;
    public set accountName(v: string) { this._accountName = v; } public get accountName(): string { return this._accountName;} private _accountName: string;
    public set accountNumber(v: string) { this._accountNumber = v; } public get accountNumber(): string { return this._accountNumber;} private _accountNumber: string;
    public set factorNo(v: string) { this._factorNo = v; } public get factorNo(): string { return this._factorNo;} private _factorNo: string;
    public set payerName(v: string) { this._payerName = v; } public get payerName(): string { return this._payerName;} private _payerName: string;
    public set fileName(v: string) { this._fileName = v; } public get fileName(): string { return this._fileName;} private _fileName: string;
    public set fileId(v: string) { this._fileId = v; } public get fileId(): string { return this._fileId;} private _fileId: string;
    public set hasAttachment(v: boolean) { this._hasAttachment = v; } public get hasAttachment(): boolean { return this._hasAttachment;} private _hasAttachment: boolean;
    
    async download(){
        this._typedParent.downloadAttachment(this.fileId,this.fileName);
    }

    async confirm(){
        try {
            let confirmation =await this.messageBoxSuccessYesNo("آیا از تایید اطمینان دارید؟","تایید تراکنش");
            if(confirmation=="no")
                return;
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/ConfirmTransfer',{
                TransferId:this.id
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess("عملیات با موفقیت انجام شد","تایید تراکنش");
                this.status = 'تایید شده';
                this.isSpecified = true;
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('امکان تایید وجود ندارد.',"خطا")
        } finally {
            this.isLoading = false;
        }
    }
    async reject(){
        try {
            let confirmation =await this.messageBoxWarningYesNo("آیا از رد درخواست تراکنش اطمینان دارید؟","رد تراکنش");
            if(confirmation=="no")
                return;
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/RejectTransfer',{
                TransferId:this.id
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess("عملیات با موفقیت انجام شد","رد تراکنش");
                this.status = 'رد شده';
                this.isSpecified = true;
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('امکان رد وجود ندارد.',"خطا")
        } finally {
            this.isLoading = false;
        }
    }
}
